export const whereAreYou = [
    {
        id: 1,
        card: '/images/acomodation1.png',
    },
    {
        id: 2,
        card: '/images/acomodation2.png',
    },
    {
        id: 3,
        card: '/images/acomodation3.png',
    },
    {
        id: 4,
        card: '/images/acomodation5.png',
    },
];
